import { render, staticRenderFns } from "./AdminCampaignsPopUp.vue?vue&type=template&id=21eb5160&scoped=true"
import script from "./AdminCampaignsPopUp.vue?vue&type=script&lang=js"
export * from "./AdminCampaignsPopUp.vue?vue&type=script&lang=js"
import style0 from "./AdminCampaignsPopUp.vue?vue&type=style&index=0&id=21eb5160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eb5160",
  null
  
)

export default component.exports